var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pencil_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7 5.3l-5-5c-.2-.3-.6-.4-1-.3l-7 2c-.3.1-.6.5-.7.8L.1 14.5l6-6c-.2-.7 0-1.4.5-1.9.8-.8 2-.8 2.8 0 .8.8.8 2 0 2.8-.5.5-1.3.7-1.9.5l-6 6L13.2 14c.4-.1.7-.3.8-.7l2-7c.1-.4 0-.8-.3-1z",
    fill: "#4B3479"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pencil_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}

export default SvgPencil;